module.exports = "/_next/static/images/ad56f74a09559535c051d4b4fca68eec-background@3x.png.webp";